import { collection, doc, getDoc, getDocs, limit, orderBy, query, updateDoc, where } from 'firebase/firestore'
import { defineStore } from 'pinia'
import { db } from './firebase'
export const useClosetStore = defineStore({
  id: 'closet',
  state: () => ({
    owner: null,
    closetList: [],
    fromHome: false
  }),
  getters: {
    
  },
  actions: {
    async queryOwner(email) {
      const userRef = doc(db, 'User', email)
      const clotheRef = collection(db, 'Clothe')
      try {
        const userSnap = await getDoc(userRef)
        const clotheSnap = await getDocs(query(clotheRef, where('Email', '==', email)))
        if (!userSnap.exists()) {
          return { state: 'NOT_FOUND' }
        }
        this.owner = { key: userSnap.id, ...userSnap.data() }
        this.closetList = clotheSnap.docs.map(e => ({ key: e.id, ...e.data() }))
        return { state: 'SUCCESS' }
      } catch (error) {
        return { state: 'ERROR' }
      }
    },
    async queryClotheCount() {
      const clotheRef = collection(db, 'Clothe')
      const sanpshot = await getDocs(query(clotheRef, orderBy('編號', 'desc'), limit(1)))
      const data = sanpshot.docs[0].data()
      console.log(data)
      return data['編號']
    },
    async recordShareClick() {
      const userRef = doc(db, 'User', this.owner['email'])
      try {
        await updateDoc(userRef, { shareClickCount: this.owner.shareClickCount ? this.owner.shareClickCount + 1 : 1 })
        this.owner.shareClickCount++
      } catch (error) {
        console.log(error)
      }
    },
    changeFromHomeState(bool) {
      this.fromHome = bool
    }
  }
})
